import { Bean, FormContextValues, ValidationRules } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../../../../translations';

const DIAGNOSIS_ADDITIONAL_INFORMATION_MAX_LENGTH = 300;
const DIAGNOSIS_ADDITIONAL_INFORMATION_FIELD_NAME = 'additionalInformation';

const VALIDATION_RULES: ValidationRules<Bean> = {
   maxLength: DIAGNOSIS_ADDITIONAL_INFORMATION_MAX_LENGTH,
};

export type DiagnosisAdditionalInformationFormBeanPart = {
   [DIAGNOSIS_ADDITIONAL_INFORMATION_FIELD_NAME]: string | null;
};

type DiagnosisAdditionalInformationTextareaProps = Pick<
   FormContextValues<DiagnosisAdditionalInformationFormBeanPart>,
   'register'
>;

export const DiagnosisAdditionalInformationTextarea = (
   props: DiagnosisAdditionalInformationTextareaProps
): JSX.Element => {
   return (
      <Textarea
         controller={props.register(DIAGNOSIS_ADDITIONAL_INFORMATION_FIELD_NAME, VALIDATION_RULES)}
         rows={5}
         maxRows={5}
         maxLength={DIAGNOSIS_ADDITIONAL_INFORMATION_MAX_LENGTH}
         label={visitDetailsTranslationKeys.diagnoses.diagnosisAdditionalInformation.form.additionalInformation.label}
         placeholder={
            visitDetailsTranslationKeys.diagnoses.diagnosisAdditionalInformation.form.additionalInformation.placeholder
         }
         testId={'diagnosisAdditionalInformation'}
      />
   );
};
